import app from "./../app";

const Payment2Checkout = {};
const GANTT_PRO_PLAN_ID = 13;

let needReload = false;

/*
*
* */
Payment2Checkout.openPaymentPopup = function (data) {
  const TwoCoInlineCart = window.TwoCoInlineCart;
  let coupon = '';

  if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
    // coupon = '/' + user.affiliate.coupon;
    coupon = user.affiliate.coupon;
  }

  const product = {
    planId: data.newPlan.planId,
    userCount: data.newPlan.userCount,
    isAnnual: +(data.newPeriod !== 'month')
  }

  webix.ajax()
    .headers({"Content-Type": "application/json"})
    // .get('/payment/plan/signature/' + productKey + coupon)
    .get('/payment/plan/signature/' + coupon, {data: product})
    .then(res => {
      const resJSON = res.json();
      const signature = resJSON.signature;
      const product = resJSON.product;

      TwoCoInlineCart.products.removeAll();
      TwoCoInlineCart.cart.resetAdditionalFields();
      TwoCoInlineCart.cart.removeCoupons();
      TwoCoInlineCart.cart.setReset(true);

      TwoCoInlineCart.products.add(product);
      TwoCoInlineCart.billing.setEmail(user.email);
      TwoCoInlineCart.cart.setLanguage(user.locale);

      TwoCoInlineCart.cart.setCurrency('USD');


      if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
        TwoCoInlineCart.cart.addCoupons([user.affiliate.coupon]);
      }

      TwoCoInlineCart.cart.setSignature(signature);
      TwoCoInlineCart.cart.setExternalCustomerReference(resJSON.externalCustomerReference);


      TwoCoInlineCart.cart.setTest(user.isTestPaymentMode);

      const cartClosedhandlerGuid = TwoCoInlineCart.events.subscribe('cart:closed', function () {
        document.querySelector('body').style.overflow = '';
        TwoCoInlineCart.events.unsubscribe('cart:closed', cartClosedhandlerGuid);
        if (needReload) {
          window.location.reload();
        }
      });

      TwoCoInlineCart.cart.checkout();
    });
};

Payment2Checkout.tempSubscription = function (orderID, currentProductKey) {
  return webix.ajax().post('/payment/plan/processing', {
    orderId: orderID,
    currentProductKey: currentProductKey,
    planID: GANTT_PRO_PLAN_ID
  });
};

app.socketNotify.on('notify:tempSubscription', function (data) {
  needReload = true;
});


export default Payment2Checkout;
